import type { PropsWithChildren } from "react";
import { DrillPageContext } from "#drill-page-context";
import { useDrillPageContextValue } from "#drill-page-context-value";

export function DrillPageContextProvider({
  children,
  ...props
}: PropsWithChildren<Parameters<typeof useDrillPageContextValue>[0]>) {
  const value = useDrillPageContextValue(props);
  return <DrillPageContext.Provider value={value}>{children}</DrillPageContext.Provider>;
}
